import { useContext } from 'react'
import SnackbarContext from '@providers/SnackbarProvider'

export default function useSnackbar() {
  const SnackbarValues = useContext(SnackbarContext)

  return SnackbarValues
}
